/*
 * Copyright (c) 2023
 * 
 * Created Date: Tuesday, October 3rd 2023, 10:54:01 am
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
import { Tooltip } from 'antd'
import React from 'react'

export default function CellTable({ data, icon = null, dataTooltipicon = "" }) {
    return (
        <>
            <div className="wrapper-inner-cell">
                {icon && <Tooltip placement="topLeft" title={dataTooltipicon}>
                    <div className="icon">{icon}</div>
                </Tooltip>}
                <Tooltip placement="topLeft" title={data}>
                    <div className="ellipsis">{data}</div>
                </Tooltip>
            </div>
        </>
    )
}
